import SystemHelper, { SystemConstants } from 'features/System/systemHelper';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import KTSwitch, {
  KTSwitchSize,
  KTSwitchType,
} from 'general/components/OtherKeenComponents/KTFormControls/KTSwitch';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useState } from 'react';

DialogRejectEnergyBillView.propTypes = {
  item: PropTypes.object,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogRejectEnergyBillView({ item, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const [loading, setLoading] = useState(false);
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [reason, setReason] = useState('');
  const [checked, setChecked] = useState(true);

  // MARK: ---- METHODS ----
  const handleSubmit = async () => {
    setReadyToValidate(true);
    if (!Utils.isValid(reason)) {
      ToastHelper.showError('Vui lòng nhập lý do');
      return;
    }
    const params = {
      status: SystemConstants.EnergyBillStatus.REJECTED,
      rejectReason: reason,
    };
    setLoading(true);
    const res = await SystemHelper.API.EnergyBill.requestUpdateEnergyBill(item?.billId, params);
    setLoading(false);
    if (_.isBoolean(res) && res) {
      ToastHelper.showSuccess('Cập nhật thành công');
      onDone();
    } else if (_.isString(res)) {
      ToastHelper.showError(res);
    }
  };

  return (
    <div>
      <div className="row m-0 p-0 px-2">
        <div className="col-12 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Lý do', true)}
            <KTFormTextArea
              placeholder="Nhập lý do"
              name="reason"
              value={reason}
              onChange={(value) => {
                setReason(value);
              }}
              enableCheckValid={readyToValidate}
              isValid={Utils.isValid(reason)}
              isTouched={readyToValidate}
              feedbackText={!Utils.isValid(reason) ? 'Vui lòng nhập lý do' : ''}
            />
          </div>
        </div>
        <div className="col-12 mb-4 px-2">
          <div className="d-flex align-items-center gap-2">
            <KTSwitch
              name="sentToAgency"
              size={KTSwitchSize.sm}
              checked={checked}
              onChange={(value) => {
                setChecked(value);
              }}
              type={KTSwitchType.outline}
              showIcon={true}
              additionalClassName="switch-success"
            />
            <span
              className="cursor-pointer"
              style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[600])}
              onClick={() => setChecked(!checked)}
            >
              Gửi yêu cầu chỉnh sửa tới NĐT/chủ mặt bằng
            </span>
          </div>
        </div>
      </div>
      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        {UIHelper.buildRedButton('Xác nhận', handleSubmit, null, false, loading)}
      </div>
    </div>
  );
}

export default DialogRejectEnergyBillView;
